export const COUNTRIES_SHORT = {
  default: 'usa',
  usa: 'usa',
  mexico: 'mexico',
  france: 'france'
};
